
import React, {FC, PropsWithChildren} from 'react';
import classNames from 'classnames';

import Bars from './svgs/bars.inline.svg';

import * as styles from './styles.module.scss';

type BarsSpinnerProps = PropsWithChildren<{
	className?: string
}>;

export const BarsSpinner: FC<BarsSpinnerProps> = ({className, children}) => (
	<div className={classNames(styles.spinner, className)}>
		<Bars />
		{children}
	</div>
);
